// extracted by mini-css-extract-plugin
export default {"btn_div":"UploadVideo_btn_div__V5+8N","btn_div_gallery":"UploadVideo_btn_div_gallery__raaIA","height_box":"UploadVideo_height_box__TUVrC"};